import WidgetAvgAnswers from './WidgetAvgAnswers';



export default WidgetAvgAnswers;
